import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import usePageTracking from "../../../hooks/usePageTracking";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";
import { addToCart, fetchProducts } from "../../../redux/slices/shopSlice";
import "./products.scss";
import { Card, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { sessionId } from "../../../redux/slices/cityComparisonSlice";
import { addInCart, shopVisits } from "../../../redux/slices/shopTrackingSlice";

const Products = () => {
  const dispatch = useDispatch();

  // Track Activity
  usePageTracking("SHOP");
  useEffect(() => {
    dispatch(activityStart({ page_name: "SHOP", platform: "web" }));
    return () => dispatch(activityEnd({ page_name: "SHOP" }));
  }, [dispatch]);
  const { products, loading } = useSelector((state) => state.shop);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);


  const user = useSelector((state) => state.auth?.user);


  useEffect(() => {
    if (!user) {
      sessionStorage.removeItem("comparison_session_id");
      sessionStorage.removeItem("session_expiry");

      console.log("🧹 Session cleared on logout");
    }
  }, [user]);
  useEffect(() => {
    if (!user?.id) return;

    const existingSession = sessionStorage.getItem("comparison_session_id");
    const expiry = sessionStorage.getItem("session_expiry");

    if (existingSession && expiry && Date.now() < Number(expiry)) {
      
      return;
    }
    dispatch(sessionId()).then((res) => {
      const data = res.payload?.data;

      if (data?.session_id) {
        sessionStorage.setItem("comparison_session_id", data.session_id);

        const expiryTime = Date.now() + data.expires_in * 1000;
        sessionStorage.setItem("session_expiry", expiryTime);

        
      }
    });
  }, [user]);

  useEffect(() => {
    const sessionId = sessionStorage.getItem("comparison_session_id");

    const payload = {
      user_id: user?.id || null,
      session_id: sessionId,
      platform: "web",
    };

    if (sessionId) {
      dispatch(shopVisits(payload));
    }
  }, [user, dispatch]);
  if (loading)
    return (
      <div className="loader-wrapper">
        <Spinner animation="border" role="status" />
        <span className="ms-2">Loading products...</span>
      </div>
    );
  return (
    <div className="product-content">
      <Card className="p-0">
        <Card.Body>
          <div className="header-banner">
            <h4>Our Products</h4>
            <p>Explore our exclusive selection of premium products</p>
          </div>
        </Card.Body>
      </Card>
      <div className="products-grid g-3 row">
        {products.map((item) => (
          <div
            key={item.id}
            className="product-card col-sm-6 col-xl-4"
            onClick={() => navigate(`/shop/products-detail/${item.id}`)}
          >
            <div className="content-wrap">
              <div className="product-banner">
                <img src={item.images?.[0]?.src} alt={item.name} />
              </div>

              <div className="product-body">
                <div className="product-dec">{item.name}</div>

                <div className="price">
                  <span className="old-price">${item.regular_price}</span>
                  <span className="new-price">${item.price}</span>
                </div>

                {/* <button
                  className="add-cart"
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch(addToCart(item));
                    navigate("/shop/cart");
                  }}
                >
                  Add to cart
                </button> */}
                <button
                  className="btn btn-primary add-cart"
                  onClick={(e) => {
                    e.stopPropagation();

                    const sessionId = sessionStorage.getItem("comparison_session_id");

                    const payload = {
                      event_type: "add_to_cart",
                      user_id: user?.id || null,
                      session_id: sessionId,
                      course_name: item?.name,
                      platform: "web",
                      // metadata: {
                      //   product_id: item?.id,
                      //   price: item?.price,
                      // },
                    };

                    if (sessionId) {
                      dispatch(addInCart(payload));
                    }

                    dispatch(addToCart(item));
                    navigate("/shop/cart");
                  }}
                >
                  Add to cart
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
